import React, { useCallback, useEffect, useState } from "react";
import "../Components/OwnerPage.css";
import { useNavigate } from "react-router-dom";
import DashboardIcon from "@mui/icons-material/Dashboard";
import DirectionsCarIcon from "@mui/icons-material/DirectionsCar";
import BookOnlineIcon from "@mui/icons-material/BookOnline";
import ContactPhoneIcon from "@mui/icons-material/ContactPhone";
import MiscellaneousServicesIcon from "@mui/icons-material/MiscellaneousServices";
import AppRegistrationIcon from "@mui/icons-material/AppRegistration";
import FlightTakeoffIcon from "@mui/icons-material/FlightTakeoff";
import PersonIcon from "@mui/icons-material/Person";
import EventIcon from "@mui/icons-material/Event";
import SwapHorizIcon from "@mui/icons-material/SwapHoriz";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import LogoutIcon from "@mui/icons-material/Logout";
import ReviewsIcon from "@mui/icons-material/Reviews";
import LocalTaxiIcon from "@mui/icons-material/LocalTaxi";
import ContactsIcon from "@mui/icons-material/Contacts";
import HomeIcon from "@mui/icons-material/Home";
import BusinessCenterIcon from "@mui/icons-material/BusinessCenter";
import InfoIcon from "@mui/icons-material/Info";
import DashboardChart from "./DashboardChart";
import { DataGrid } from "@mui/x-data-grid";
import { Button, TextField, Box } from "@mui/material";
import { saveAs } from "file-saver";
import * as XLSX from "xlsx";
import { auth, db } from "../firebase-config";
import { collection, getDocs, addDoc, query, where, deleteDoc, doc, updateDoc, setDoc, getDoc, } from "firebase/firestore";
import { createUserWithEmailAndPassword, fetchSignInMethodsForEmail, onAuthStateChanged } from "firebase/auth";
import AddIcon from "@mui/icons-material/Add";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import CircularProgress from "@mui/material/CircularProgress";
const OwnerPage = () => {
  const navigate = useNavigate();
  const transferMenus = [
    "Airporttransfers",
    "chauffers",
    "citytocitytransfers",
    "eventtransportation",
    "Hirebythehour",
    "Aboutus",
    "Businesspage"
  ];
  const menuSections = [
    {
      title: "Main",
      items: [
        { name: "Dashboard", icon: <DashboardIcon /> },
        { name: "Bookings", icon: <BookOnlineIcon /> },
        { name: "PickupTransportation", icon: <LocalTaxiIcon /> },
        { name: "Reviews", icon: <ReviewsIcon /> },
        { name: "ClientContactData", icon: <ContactsIcon /> },
      ],
    },
    {
      title: "Management",
      items: [
        { name: "Cars", icon: <DirectionsCarIcon /> },
        { name: "Services", icon: <MiscellaneousServicesIcon /> },
        { name: "Contact", icon: <ContactPhoneIcon /> },
        { name: "HomePage", icon: <HomeIcon /> },
      ],
    },
    {
      title: "Transfers",
      items: [
        { name: "Airporttransfers", icon: <FlightTakeoffIcon /> },
        { name: "chauffers", icon: <PersonIcon /> },
        { name: "eventtransportation", icon: <EventIcon /> },
        { name: "citytocitytransfers", icon: <SwapHorizIcon /> },
        { name: "Hirebythehour", icon: <AccessTimeIcon /> },
        { name: "Aboutus", icon: <InfoIcon /> },
        { name: "Businesspage", icon: <BusinessCenterIcon /> },
      ],
    },
    {
      title: "Users",
      items: [
        { name: "Registerpage", icon: <AppRegistrationIcon /> },
      ],
    },
    {
      title: "System",
      items: [
        { name: "Logout", icon: <LogoutIcon />, isLogout: true },
      ],
    },
  ];
  const [selectedMenu, setSelectedMenu] = useState("Dashboard");
  const [showModal, setShowModal] = useState(null);
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [searchText, setSearchText] = useState("");
  const [editData, setEditData] = useState(null);
  const [showEditModal, setShowEditModal] = useState(false);
  const [isSaving, setIsSaving] = useState(false);
  const [isUpdating, setIsUpdating] = useState(false);
  const [loading, setLoading] = useState(false);
  /* TABLE DATA */
  const [formData, setFormData] = useState({
    name: "",
    type: "",
    seats: "",
    price: "",
    description: "",
    content: "",
    image: "",
    imageFile: null,
    rating: "",
    headerTitle: "",
    headerDescription: "",
    headerimage: "",
    headerimageFile: null,
    email: "",
    password: "",
    confirmPassword: "",
    mobilenumber: "",
    address: "",
    mapUrl: "",
    facebook: "",
    instagram: "",
    linkedin: "",
    youtube: "",
  });
  const [tableData, setTableData] = useState({
    Dashboard: [],
    Cars: [],
    Bookings: [],
    Navbar: [],
    Contact: [],
    Services: [],
    Registerpage: [],
    Airporttransfers: [],
    chauffers: [],
    eventtransportation: [],
    citytocitytransfers: [],
    PickupTransportation: [],
    Hirebythehour: [],
    Reviews: [],
    HomePage: [],
    ClientContactData: [],
  });
  const [profile, setProfile] = useState(null);
  const uploadImageToCloudinary = async (file) => {
    const data = new FormData();
    data.append("file", file);
    data.append("upload_preset", "syedimages"); // ✅ your preset
    const res = await fetch(
      "https://api.cloudinary.com/v1_1/djdhs7pck/image/upload",
      {
        method: "POST",
        body: data,
      }
    );
    const result = await res.json();
    return result.secure_url;
  };
  const fetchData = useCallback(async () => {
    try {
      setLoading(true);
      let data = [];
      // 🔥 REGISTER PAGE → fetch from "users" collection
      if (selectedMenu === "Registerpage") {
        const snapshot = await getDocs(collection(db, "users"));
        data = snapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }));
      }
      else if (selectedMenu === "Bookings") {
        const snapshot = await getDocs(
          collection(db, "bookings")
        );
        data = snapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }));
      }
      else if (selectedMenu === "ClientContactData") {
        const snapshot = await getDocs(
          collection(db, "contactMessages")
        );
        data = snapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }));
      }
      else {
        const q = query(
          collection(db, "ownerPageDatas"),
          where("selectedmenutype", "==", selectedMenu)
        );
        const snapshot = await getDocs(q);
        data = snapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }));
      }
      setTableData((prev) => ({
        ...prev,
        [selectedMenu]: data,
      }));

    } catch (error) {
      toast.error(error);
    }
    finally {
      setLoading(false);
    }
  }, [selectedMenu]);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, async (user) => {
      try {
        if (!user) {
          setProfile(null);
          return;
        }
        const docRef = doc(db, "users", user.uid);
        const docSnap = await getDoc(docRef);
        if (docSnap.exists()) {
          setProfile({
            id: docSnap.id,
            ...docSnap.data(),
          });
        }
      } catch (error) {
        console.error("Profile fetch error:", error);
      }
    });
    return unsubscribe;
  }, []);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  useEffect(() => {
    if (profile) {
      // console.log("PROFILE LOADED:", profile);
    }
  }, [profile]);
  const handleMenuClick = (item) => {
    if (item.isLogout) {
      navigate("/");
      return;
    }
    setSelectedMenu(item.name);
    setSidebarOpen(false);
  };
  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };
  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      setIsSaving(true);
      /* ================= REGISTER ================= */
      if (selectedMenu === "Registerpage") {
        // if (!formData.email || !formData.password) {
        //   toast.warning("Email & Password required ❌");
        //   return;
        // }
        // if (formData.password !== formData.confirmPassword) {
        //   toast.warning("Passwords do not match ❌");
        //   return;
        // }
        const methods = await fetchSignInMethodsForEmail(auth, formData.email);
        if (methods.length > 0) {
          toast.warning("Email already exists ❌");
          return;
        }
        const userCredential = await createUserWithEmailAndPassword(
          auth,
          formData.email,
          formData.password
        );
        const user = userCredential.user;
        let imageUrl = "";
        if (formData.imageFile) {
          try {
            imageUrl = await uploadImageToCloudinary(formData.imageFile);
          } catch (imgErr) {
            toast.error("Image upload failed:", imgErr);
            imageUrl = "";
          }
        }
        await setDoc(doc(db, "users", user.uid), {
          uid: user.uid,
          name: formData.name || "",
          email: formData.email || "",
          mobilenumber: formData.mobilenumber || "",
          address: formData.address || "",
          image: imageUrl || "",
          selectedmenutype: selectedMenu,
          createdAt: new Date(),
        });
        toast.success("User Registered Successfully ✅");
        setFormData({
          name: "",
          email: "",
          password: "",
          confirmPassword: "",
          mobilenumber: "",
          address: "",
          image: "",
          imageFile: null
        });
        setShowModal(null);
        fetchData();
        return;
      }
      if (
        selectedMenu === "Services" ||
        selectedMenu === "PickupTransportation"
      ) {
        if (!formData.description) {
          // alert("Description is required ❌");
          toast.warning("Description is required ❌");
          return;
        }
        if (!formData.imageFile) {
          // alert("Please upload image ❌");
          toast.warning("Please upload image ❌");
          return;
        }
        const imageUrl = await uploadImageToCloudinary(formData?.imageFile);
        await addDoc(collection(db, "ownerPageDatas"), {
          description: formData.description,
          image: imageUrl,
          selectedmenutype: selectedMenu,
          createdAt: new Date(),
        });
        toast.success("Service Added Successfully ✅");
        setFormData({
          description: "",
          image: "",
          imageFile: null,
        });
        setShowModal(null);
        fetchData();
        return;
      }
      if (selectedMenu === "HomePage") {
        if (
          !formData.headerTitle ||
          !formData.headerDescription
        ) {
          toast.warning("Header fields required ❌");
          return;
        }
        if (!formData.headerimageFile) {
          toast.warning("Please upload image ❌");
          return;
        }
        const headerimageUrl = await uploadImageToCloudinary(
          formData.headerimageFile
        );
        await addDoc(collection(db, "ownerPageDatas"), {
          headerTitle: formData.headerTitle,
          headerDescription: formData.headerDescription,
          headerimage: headerimageUrl,
          selectedmenutype: selectedMenu,
          createdAt: new Date(),
        });
        toast.success("Homepage Added Successfully ✅");
        setFormData({
          headerTitle: "",
          headerDescription: "",
          headerimage: "",
          headerimageFile: null,
          description: "",
          content: "",
        });
        setShowModal(null);
        fetchData();
        return;
      }
      if (selectedMenu === "Reviews") {
        if (!formData.name) {
          toast.warning("Customer name is required ❌");
          return;
        }
        if (!formData.description) {
          toast.warning("Review description is required ❌");
          return;
        }
        if (!formData.rating) {
          toast.warning("Star rating is required ❌");
          return;
        }
        if (!formData.imageFile) {
          toast.warning("Please upload customer image ❌");
          return;
        }
        const imageUrl = await uploadImageToCloudinary(
          formData?.imageFile
        );
        await addDoc(collection(db, "ownerPageDatas"), {
          name: formData.name,
          description: formData.description,
          rating: Number(formData.rating),
          image: imageUrl,
          selectedmenutype: selectedMenu,
          createdAt: new Date(),
        });
        toast.success("Review Added Successfully ✅");
        setFormData({
          name: "",
          description: "",
          rating: "",
          image: "",
          imageFile: null,
        });
        setShowModal(null);
        fetchData();
        return;
      }
      if (selectedMenu === "Contact") {
        const imageUrl = formData?.imageFile
          ? await uploadImageToCloudinary(formData.imageFile)
          : "";
        const payload = {
          selectedmenutype: selectedMenu,
          createdAt: new Date(),
        };
        if (formData.name) payload.name = formData.name;
        if (formData.address) payload.address = formData.address;
        if (formData.mobilenumber) payload.mobilenumber = formData.mobilenumber;
        if (formData.mapUrl) payload.mapUrl = formData.mapUrl;
        if (formData.facebook) payload.facebook = formData.facebook;
        if (formData.instagram) payload.instagram = formData.instagram;
        if (formData.linkedin) payload.linkedin = formData.linkedin;
        if (formData.youtube) payload.youtube = formData.youtube;

        if (imageUrl) payload.image = imageUrl;
        await addDoc(collection(db, "ownerPageDatas"), payload);
        toast.success(" contact Saved Successfully ✅");
        setFormData({
          name: "",
          address: "",
          mobilenumber: "",
          mapUrl: "",
          facebook: "",
          instagram: "",
          linkedin: "",
          youtube: "",
          image: "",
          imageFile: null,
        });
        setShowModal(null);
        fetchData();
        return;
      }
      if (transferMenus?.includes(selectedMenu)) {
        const imageUrl = formData?.imageFile
          ? await uploadImageToCloudinary(formData.imageFile)
          : "";
        const headerimageUrl = formData?.headerimageFile
          ? await uploadImageToCloudinary(formData.headerimageFile)
          : "";
        const payload = {
          selectedmenutype: selectedMenu,
          createdAt: new Date(),
        };
        if (formData.headerTitle) payload.headerTitle = formData.headerTitle;
        if (formData.headerDescription) payload.headerDescription = formData.headerDescription;
        if (headerimageUrl) payload.headerimage = headerimageUrl;
        if (formData.description) payload.description = formData.description;
        if (formData.content) payload.content = formData.content;
        if (imageUrl) payload.image = imageUrl;
        await addDoc(collection(db, "ownerPageDatas"), payload);
        toast.success("Saved Successfully ✅");
        setFormData({
          headerTitle: "",
          headerDescription: "",
          headerimage: "",
          headerimageFile: null,
          description: "",
          content: "",
          image: "",
          imageFile: null,
        });
        setShowModal(null);
        fetchData();
        return;
      }
      /* ================= OTHER DATA ================= */
      if (!formData.name) {
        toast.warning("Name is required ❌");
        return;
      }
      const imageUrl = await uploadImageToCloudinary(formData?.imageFile);
      await addDoc(collection(db, "ownerPageDatas"), {
        name: formData.name || "",
        type: formData.type || "",
        seats: formData.seats || "",
        price: formData.price || "",
        description: formData.description || "",
        content: formData.content || "",
        image: imageUrl,
        selectedmenutype: selectedMenu,
        createdAt: new Date(),
      });
      toast.success("Saved Successfully ✅");
      setFormData({
        name: "",
        type: "",
        seats: "",
        price: "",
        description: "",
        content: "",
        image: "",
        imageFile: null,
      });
      setShowModal(null);
      fetchData();
    } catch (error) {
      toast.error(error.message);
    }
    finally {
      setIsSaving(false);
    }
  };
  /* ROWS */
  const rows = (tableData[selectedMenu] || [])
    .filter((item) =>
      (item.name || item.description || "")
        .toLowerCase()
        .includes(searchText.toLowerCase())
    )
    .map((item) => ({
      id: item.id,
      ...item,
    }));
  /* ================= DELETE ================= */
  const handleDelete = async (id) => {
    try {
      if (selectedMenu === "Registerpage") {
        await deleteDoc(doc(db, "users", id));
      }
      else {
        await deleteDoc(doc(db, "ownerPageDatas", id));
      }
      const updated = tableData[selectedMenu].filter(
        (item) => item.id !== id
      );
      setTableData({
        ...tableData,
        [selectedMenu]: updated,
      });
      setShowEditModal(false); // Close modal
      toast.success("Deleted Successfully ✅");
    } catch (error) {
      toast.error(error);
    }
  };
  const handleUpdate = async () => {
    try {
      setIsUpdating(true);
      if (!editData?.id) return;

      let imageUrl = editData.image;
      let headerimageUrl = editData.headerimage;

      if (editData.imageFile) {
        imageUrl = await uploadImageToCloudinary(
          editData.imageFile
        );
      }
      if (editData.headerimageFile) {
        headerimageUrl = await uploadImageToCloudinary(
          editData.headerimageFile
        );
      }
      const ref =
        selectedMenu === "Registerpage"
          ? doc(db, "users", editData.id)
          : doc(db, "ownerPageDatas", editData.id);
      await updateDoc(ref, {
        name: editData.name || "",
        email: editData.email || "",
        description: editData.description || "",
        content: editData.content || "",
        price: editData.price || "",
        seats: editData.seats || "",
        type: editData.type || "",
        rating: editData.rating || "",
        image: imageUrl || "",
        headerimage: headerimageUrl || "",
        headerTitle: editData.headerTitle || "",
        headerDescription: editData.headerDescription || "",
        mobilenumber: editData.mobilenumber || "",
        password: editData.password || "",
        confirmpassword: editData.confirmpassword || "",
        address: editData.address || "",
        mapUrl: editData.mapUrl || "",
        facebook: editData.facebook || "",
        instagram: editData.instagram || "",
        linkedin: editData.linkedin || "",
        youtube: editData.youtube || "",
      });
      toast.success("Updated Successfully ✅");
      setShowEditModal(false);
      setEditData(null);
      fetchData();
    } catch (error) {
      toast.error(error.message);
    }
    finally {
      setIsUpdating(false);
    }
  };
  const getColumns = () => {
    /* ================= REGISTER PAGE ================= */
    if (selectedMenu === "Registerpage") {
      return [
        { field: "name", headerName: "Name", flex: 1 },
        { field: "email", headerName: "Email", flex: 1 },
        { field: "uid", headerName: "User ID", flex: 1 },
        { field: "mobilenumber", headerName: "Mobile number", flex: 1 },
        { field: "address", headerName: "ADDRESS", flex: 1 },
        {
          field: "image",
          headerName: "Image",
          width: 100,
          renderCell: (params) =>
            params.value ? (
              <img src={params.value} alt="Profile" style={{ width: 50, height: 50, borderRadius: 6 }} />
            ) : null,
        },
        {
          field: "actions",
          headerName: "Actions",
          width: 120,
          renderCell: (params) => (
            <Button
              variant="contained"
              color="error"
              size="small"
              onClick={() => handleDelete(params.row.id)}
            >
              Delete
            </Button>
          ),
        },
      ];
    }
    /* ================= CARS ================= */
    if (selectedMenu === "Cars") {
      return [
        { field: "name", headerName: "Car Name", flex: 1 },
        { field: "type", headerName: "Type", flex: 1 },
        { field: "seats", headerName: "Seats", flex: 1 },
        { field: "price", headerName: "Price", flex: 1 },
        {
          field: "image",
          headerName: "Image",
          width: 100,
          renderCell: (params) =>
            params.value ? (
              <img src={params.value} alt="Profile" style={{ width: 50, height: 50, borderRadius: 6 }} />
            ) : null,
        },
        {
          field: "actions",
          headerName: "Actions",
          width: 120,
          renderCell: (params) => (
            <Button
              variant="contained"
              color="error"
              size="small"
              onClick={() => handleDelete(params.row.id)}
            >
              Delete
            </Button>
          ),
        },
      ];
    }
    /* ================= SERVICES (NEW) ================= */
    if (
      selectedMenu === "Reviews"
    ) {
      return [
        {
          field: "description",
          headerName: "Description",
          flex: 1,
        },
        {
          field: "image",
          headerName: "Image",
          width: 100,
          renderCell: (params) =>
            params.value ? (
              <img
                src={params.value}
                alt=""
                style={{ width: 50, height: 50, borderRadius: 6 }}
              />
            ) : null,
        },
        {
          field: "actions",
          headerName: "Actions",
          width: 120,
          renderCell: (params) => (
            <Button
              variant="contained"
              color="error"
              size="small"
              onClick={() => handleDelete(params.row.id)}
            >
              Delete
            </Button>
          ),
        },
      ];
    }
    if (
      selectedMenu === "Services" ||
      selectedMenu === "PickupTransportation"
    ) {
      return [
        {
          field: "description",
          headerName: "Description",
          flex: 1,
        },
        {
          field: "image",
          headerName: "Image",
          width: 100,
          renderCell: (params) =>
            params.value ? (
              <img
                src={params.value}
                alt=""
                style={{ width: 50, height: 50, borderRadius: 6 }}
              />
            ) : null,
        },
        {
          field: "actions",
          headerName: "Actions",
          width: 120,
          renderCell: (params) => (
            <Button
              variant="contained"
              color="error"
              size="small"
              onClick={() => handleDelete(params.row.id)}
            >
              Delete
            </Button>
          ),
        },
      ];
    }
    if (selectedMenu === "HomePage") {
      return [
        {
          field: "headerTitle",
          headerName: "Title",
          flex: 1,
        },
        {
          field: "headerDescription",
          headerName: "Description",
          flex: 1,
        },
        {
          field: "headerimage",
          headerName: "headerImage",
          width: 100,
          renderCell: (params) =>
            params.value ? (
              <img
                src={params.value}
                alt=""
                style={{ width: 50, height: 50, borderRadius: 6 }}
              />
            ) : null,
        },
        {
          field: "actions",
          headerName: "Actions",
          width: 120,
          renderCell: (params) => (
            <Button
              variant="contained"
              color="error"
              size="small"
              onClick={() => handleDelete(params.row.id)}
            >
              Delete
            </Button>
          ),
        },
      ];
    }
    if (selectedMenu === "Contact") {
      return [
        {
          field: "name",
          headerName: "Name",
          flex: 1,
        },
        {
          field: "address",
          headerName: "Address",
          flex: 1,
        },
        {
          field: "mobilenumber",
          headerName: "MobileNumber",
          flex: 1,
        },
        {
          field: "mapUrl",
          headerName: "Mapurl",
          flex: 1,
        },
        {
          field: "facebook",
          headerName: "facebook",
          flex: 1,
        },
        {
          field: "instagram",
          headerName: "instagram",
          flex: 1,
        },
        {
          field: "linkedin",
          headerName: "linkedin",
          flex: 1,
        },
        {
          field: "youtube",
          headerName: "youtube",
          flex: 1,
        },

        {
          field: "actions",
          headerName: "Actions",
          width: 120,
          renderCell: (params) => (
            <Button
              variant="contained"
              color="error"
              size="small"
              onClick={() => handleDelete(params.row.id)}
            >
              Delete
            </Button>
          ),
        },
      ];
    }
    if (transferMenus?.includes(selectedMenu)) {
      return [
        {
          field: "headerTitle",
          headerName: "HeaderTitle",
          flex: 1,
        },
        {
          field: "headerDescription",
          headerName: "HeaderDescription",
          flex: 1,
        },
        {
          field: "headerimage",
          headerName: "Headerimage",
          width: 100,
          renderCell: (params) =>
            params.value ? (
              <img
                src={params.value}
                alt=""
                style={{ width: 50, height: 50, borderRadius: 6 }}
              />
            ) : null,
        },
        {
          field: "description",
          headerName: "Description",
          flex: 1,
        },
        {
          field: "content",
          headerName: "Content",
          flex: 1,
        },
        {
          field: "image",
          headerName: "Image",
          width: 100,
          renderCell: (params) =>
            params.value ? (
              <img
                src={params.value}
                alt=""
                style={{ width: 50, height: 50, borderRadius: 6 }}
              />
            ) : null,
        },
        {
          field: "actions",
          headerName: "Actions",
          width: 120,
          renderCell: (params) => (
            <Button
              variant="contained"
              color="error"
              size="small"
              onClick={() => handleDelete(params.row.id)}
            >
              Delete
            </Button>
          ),
        },
      ];
    }
    /* ================= BOOKINGS ================= */
    if (selectedMenu === "Bookings") {
      return [
        {
          field: "name",
          headerName: "Customer Name",
          flex: 3,
        },
        {
          field: "email",
          headerName: "Email",
          flex: 3,
        },
        {
          field: "carType",
          headerName: "Car Type",
          flex: 3,
        },
        {
          field: "carSeats",
          headerName: "Seats",
          flex: 3,
        },
        {
          field: "carPrice",
          headerName: "Price",
          flex: 3,
        },
        {
          field: "tripType",
          headerName: "Trip Type",
          flex: 3,
        },
        {
          field: "pickup",
          headerName: "Pickup",
          flex: 3,
        },
        {
          field: "hours",
          headerName: "Hours",
          flex: 3,
        },
        {
          field: "date",
          headerName: "Date",
          flex: 3,
        },

        {
          field: "time",
          headerName: "Time",
          flex: 3,
        },
        {
          field: "actions",
          headerName: "Actions",
          width: 120,
          renderCell: (params) => (
            <Button
              variant="contained"
              color="error"
              size="small"
              onClick={() =>
                handleDelete(params.row.id)
              }
            >
              Delete
            </Button>
          ),
        },
      ];
    }
    /* ================= CONTACT DATA ================= */
    if (selectedMenu === "ClientContactData") {
      return [
        { field: "name", headerName: "Name", flex: 1 },
        { field: "email", headerName: "Email", flex: 1 },
        { field: "message", headerName: "Message", flex: 2 },
        {
          field: "actions",
          headerName: "Actions",
          width: 120,
          renderCell: (params) => (
            <Button
              variant="contained"
              color="error"
              size="small"
              onClick={() => handleDelete(params.row.id)}
            >
              Delete
            </Button>
          ),
        },

      ]
    }
    /* ================= OTHER MENUS ================= */
    return [
      { field: "name", headerName: "Name", flex: 1 },
      { field: "description", headerName: "Description", flex: 1 },
      { field: "content", headerName: "Content", flex: 1 },
      {
        field: "image",
        headerName: "Image",
        width: 100,
        renderCell: (params) =>
          params.value ? (
            <img
              src={params.value}
              alt=""
              style={{ width: 50, height: 50, borderRadius: 6 }}
            />
          ) : null,
      },
      {
        field: "actions",
        headerName: "Actions",
        width: 120,
        renderCell: (params) => (
          <Button
            variant="contained"
            color="error"
            size="small"
            onClick={() => handleDelete(params.row.id)}
          >
            Delete
          </Button>
        ),
      },
    ];
  };
  const exportToExcel = () => {
    const worksheet = XLSX.utils.json_to_sheet(tableData[selectedMenu] || []);
    const workbook = XLSX.utils.book_new();

    XLSX.utils.book_append_sheet(workbook, worksheet, "Data");

    const excelBuffer = XLSX.write(workbook, {
      bookType: "xlsx",
      type: "array",
    });
    const fileData = new Blob([excelBuffer], {
      type: "application/octet-stream",
    });
    saveAs(fileData, `${selectedMenu}.xlsx`);
  };


  return (
    <div className="dashboard-container">
      {/* SIDEBAR */}
      <div className={`sidebar ${sidebarOpen ? "open" : ""}`}>

        {/* CLICKABLE PROFILE */}
        <div className="sidebar-header">
          <img
            src={
              profile?.image ||
              "https://cdn-icons-png.flaticon.com/512/149/149071.png"
            }
            alt="profile"
            className="profile-img"
          />

          <h3>{profile?.name || "Admin"}</h3>
        </div>

        {menuSections?.map((section, i) => (
          <div key={i}>

            {/* SECTION TITLE */}
            <p className="sidebar-title">{section?.title}</p>

            {section?.items?.map((item, index) => (
              <div
                key={index}
                className={`sidebar-item ${selectedMenu === item?.name ? "active" : ""
                  }`}
                onClick={() => handleMenuClick(item)}
              >
                {item.icon}
                <span>{item?.name}</span>
              </div>
            ))}
          </div>
        ))}
      </div>

      {/* OVERLAY */}
      {sidebarOpen && (
        <div
          className="sidebar-overlay"
          onClick={() => setSidebarOpen(false)}
        />
      )}

      {/* MAIN CONTENT */}
      <div className="main-content">

        <button
          className="menu-toggle"
          onClick={() => setSidebarOpen(!sidebarOpen)}
        >
          ☰
        </button>
        <h1>{selectedMenu}</h1>
        {selectedMenu === "Dashboard" ? (
          <>
            <DashboardChart />
          </>
        ) : (
          <>
            {selectedMenu !== "Bookings" && selectedMenu !== "ClientContactData" && (
              <button className="add-btn" onClick={() => setShowModal("table")}>
                <AddIcon style={{ fontSize: "22px", marginRight: "6px" }} />
                Add &nbsp;{selectedMenu}
              </button>
            )}
            <br />
            <br />
            <br />
            <ToastContainer position="top-right" autoClose={2000} />
            <Box
              sx={{
                width: selectedMenu === "Bookings" ? "180%" : "100%",
              }}
            >
              {/* TOP BAR */}
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  mb: 2,
                }}
              >
                <TextField
                  label="Search by Name"
                  variant="outlined"
                  size="small"
                  onChange={(e) => setSearchText(e.target.value)}
                />
                <Button variant="contained" onClick={exportToExcel}>
                  Export Excel
                </Button>
              </Box>
              {/* DATA GRID */}
              {loading ? (
                <div
                  style={{
                    height: "50vh",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <CircularProgress size={60} sx={{ color: "#45B2F7" }} />
                </div>
              ) : (

                <DataGrid
                  rows={rows}
                  columns={getColumns()}
                  autoHeight
                  pageSize={5}
                  rowsPerPageOptions={[5, 10, 20]}
                  disableRowSelectionOnClick
                  onRowClick={(params) => {
                    setEditData(params.row);
                    setShowEditModal(true);
                  }}
                  sx={{
                    "& .MuiDataGrid-cell": {
                      fontSize: "15px",   // ✅ body text size
                    },
                    "& .MuiDataGrid-columnHeaders": {
                      fontSize: "16px",   // ✅ header text size
                      fontWeight: "600",
                      backgroundColor: "#f5f5f5",
                    },
                    "& .MuiDataGrid-row:hover": {
                      backgroundColor: "#f1f1f1", // hover effect
                    },
                  }}
                  /* EDIT SAVE */
                  processRowUpdate={(newRow) => {
                    const updatedData = [...tableData[selectedMenu]];

                    const index = updatedData.findIndex((row) => row.id === newRow.id);
                    if (index !== -1) {
                      updatedData[index] = newRow; // ✅ correct update
                    }
                    setTableData({
                      ...tableData,
                      [selectedMenu]: updatedData,
                    });
                    return newRow;
                  }}
                />
              )
              }
            </Box>
          </>
        )}
      </div>

      {/* TABLE MODAL */}
      {showModal === "table" && (
        <div className="modal-overlay">
          <div className="modal-box">
            <h2>Add {selectedMenu}</h2>
            <br />
            <form onSubmit={handleSubmit}>
              {/* ================= CARS ================= */}
              {selectedMenu === "Cars" ? (
                <>
                  <input
                    name="name"
                    placeholder="Car Name"
                    value={formData?.name}
                    onChange={handleChange}
                    required
                  />

                  <input
                    name="type"
                    placeholder="Car Type"
                    value={formData?.type}
                    onChange={handleChange}
                    required
                  />

                  <input
                    name="seats"
                    type="number"
                    placeholder="Seats"
                    value={formData?.seats}
                    onChange={handleChange}
                    required
                  />

                  <input
                    name="price"
                    type="number"
                    placeholder="Price"
                    value={formData?.price}
                    onChange={handleChange}
                    required
                  />



                  {/* IMAGE UPLOAD */}
                  <div className="upload-field">
                    <label className="upload-label"> Upload Image
                      <input type="file" accept="image/*"
                        onChange={(e) =>
                          setFormData({
                            ...formData,
                            imageFile: e.target.files[0],
                            image: URL.createObjectURL(e.target.files[0]),
                          })
                        } /> </label>
                  </div>
                  {/* PREVIEW */}
                  {formData?.image && (
                    <img src={formData?.image} alt="preview" className="preview-img" />
                  )}


                  <div className="modal-buttons">
                    <button type="button" onClick={() => setShowModal(null)}> Cancel </button>
                    <button type="submit" disabled={isSaving}>
                      {isSaving ? "Saving..." : "Save"}
                    </button>
                  </div>
                </>
              )

                : transferMenus?.includes(selectedMenu) ? (
                  <>
                    {/* 🔥 TOP HEADER SECTION */}
                    <h3>Header Section</h3>

                    <input
                      name="headerTitle"
                      placeholder="Header Title (Top Heading)"
                      value={formData.headerTitle || ""}
                      onChange={handleChange}

                    />

                    <textarea
                      name="headerDescription"
                      placeholder="Header Description"
                      value={formData.headerDescription || ""}
                      onChange={handleChange}

                    />

                    {/* ✅ HEADER IMAGE UPLOAD */}
                    <div className="upload-field">
                      <label className="upload-label">
                        Upload Header Image
                        <input
                          type="file"
                          accept="image/*"
                          onChange={(e) =>
                            setFormData({
                              ...formData,
                              headerimageFile: e.target.files[0],
                              headerimage: URL.createObjectURL(e.target.files[0]),
                            })
                          }
                        />
                      </label>
                    </div>

                    {/* ✅ HEADER IMAGE PREVIEW */}
                    {formData.headerimage && (
                      <img
                        src={formData?.headerimage || ""}
                        alt="header preview"
                        className="preview-img"
                      />
                    )}

                    <hr style={{ margin: "15px 0" }} />

                    {/* 🔥 CARD SECTION */}
                    <h3>Content Section</h3>

                    <input
                      name="description"
                      placeholder="Card Title"
                      value={formData?.description}
                      onChange={handleChange}

                    />

                    <textarea
                      name="content"
                      placeholder="Card Content"
                      value={formData?.content}
                      onChange={handleChange}

                    />

                    {/* IMAGE UPLOAD */}
                    <div className="upload-field">
                      <label className="upload-label">
                        Upload Image
                        <input
                          type="file"
                          accept="image/*"
                          onChange={(e) =>
                            setFormData({
                              ...formData,
                              imageFile: e.target.files[0],
                              image: URL.createObjectURL(e.target.files[0]),
                            })
                          }
                        />
                      </label>
                    </div>

                    {/* PREVIEW */}
                    {formData?.image && (
                      <img
                        src={formData?.image}
                        alt="preview"
                        className="preview-img"
                      />
                    )}

                    <div className="modal-buttons">
                      <button type="button" onClick={() => setShowModal(null)}>
                        Cancel
                      </button>

                      <button type="submit" disabled={isSaving}>
                        {isSaving ? "Saving..." : "Save"}
                      </button>
                    </div>
                  </>
                )

                  : selectedMenu === "Services" ||
                    selectedMenu === "PickupTransportation" ? (
                    // ===== SERVICES FORM (NEW) =====
                    <>
                      <input
                        name="description"
                        placeholder="Service Description"
                        value={formData?.description}
                        onChange={handleChange}
                        required
                      />

                      {/* IMAGE UPLOAD */}
                      <div className="upload-field">
                        <label className="upload-label">
                          Upload Image
                          <input
                            type="file"
                            accept="image/*"
                            onChange={(e) =>
                              setFormData({
                                ...formData,
                                imageFile: e.target.files[0],
                                image: URL.createObjectURL(e.target.files[0]),
                              })
                            }
                          />
                        </label>
                      </div>

                      {/* PREVIEW */}
                      {formData?.image && (
                        <img src={formData?.image} alt="preview" className="preview-img" />
                      )}

                      <div className="modal-buttons">
                        <button type="button" onClick={() => setShowModal(null)}>
                          Cancel
                        </button>
                        <button type="submit" disabled={isSaving}>
                          {isSaving ? "Saving..." : "Save"}
                        </button>

                      </div>
                    </>
                  ) :
                    selectedMenu === "Reviews" ? (
                      <>
                        <h3>Review Section</h3>
                        {/* CUSTOMER NAME */}
                        <input
                          type="text"
                          name="name"
                          placeholder="Customer Name"
                          value={formData?.name || ""}
                          onChange={handleChange}
                          required
                        />

                        {/* REVIEW DESCRIPTION */}
                        <textarea
                          name="description"
                          placeholder="Write Review"
                          value={formData?.description || ""}
                          onChange={handleChange}
                          required
                        />

                        {/* STAR RATING */}
                        <input
                          type="number"
                          name="rating"
                          placeholder="Star Rating (1-5)"
                          min="1"
                          max="5"
                          value={formData?.rating || ""}
                          onChange={handleChange}
                          required
                        />

                        {/* CUSTOMER IMAGE */}
                        <div className="upload-field">
                          <label className="upload-label">
                            Upload Customer Image
                            <input
                              type="file"
                              accept="image/*"
                              onChange={(e) =>
                                setFormData({
                                  ...formData,
                                  imageFile: e.target.files[0],
                                  image: URL.createObjectURL(e.target.files[0]),
                                })
                              }
                            />
                          </label>
                        </div>

                        {/* IMAGE PREVIEW */}
                        {formData?.image && (
                          <img
                            src={formData?.image}
                            alt="preview"
                            className="preview-img"
                          />
                        )}

                        <div className="modal-buttons">
                          <button
                            type="button"
                            onClick={() => setShowModal(null)}
                          >
                            Cancel
                          </button>
                          <button type="submit" disabled={isSaving}>
                            {isSaving ? "Saving..." : "Save"}
                          </button>
                        </div>
                      </>
                    ) : selectedMenu === "HomePage" ? (
                      <>
                        <input
                          name="headerTitle"
                          placeholder=" Title "
                          value={formData?.headerTitle || ""}
                          onChange={handleChange}

                        />

                        <textarea
                          name="headerDescription"
                          placeholder=" Description"
                          value={formData?.headerDescription || ""}
                          onChange={handleChange}

                        />
                        {/* ✅ HEADER IMAGE UPLOAD */}
                        <div className="upload-field">
                          <label className="upload-label">
                            Upload  Image
                            <input
                              type="file"
                              accept="image/*"
                              onChange={(e) =>
                                setFormData({
                                  ...formData,
                                  headerimageFile: e.target.files[0],
                                  headerimage: URL.createObjectURL(e.target.files[0]),
                                })
                              }
                            />
                          </label>
                        </div>
                        {/* ✅ HEADER IMAGE PREVIEW */}
                        {formData?.headerimage && (
                          <img
                            src={formData?.headerimage}
                            alt="header preview"
                            className="preview-img"
                          />
                        )}

                        <div className="modal-buttons">
                          <button type="button" onClick={() => setShowModal(null)}>
                            Cancel
                          </button>
                          <button type="submit" disabled={isSaving}>
                            {isSaving ? "Saving..." : "Save"}
                          </button>

                        </div>
                      </>
                    )
                      : selectedMenu === "Contact" ? (
                        <>
                          <input
                            name="name"
                            placeholder=" Enter your name "
                            value={formData?.name || ""}
                            onChange={handleChange}

                          />

                          <input
                            name="address"
                            placeholder="Enter your Address"
                            value={formData?.address || ""}
                            onChange={handleChange}

                          />

                          <input
                            name="mobilenumber"
                            placeholder="Enter your MobileNumber"
                            value={formData?.mobilenumber || ""}
                            onChange={handleChange}


                          />

                          <textarea
                            type="text"
                            name="mapUrl"
                            placeholder="Enter your Google Maps Link"
                            value={formData?.mapUrl || ""}
                            onChange={handleChange}
                          />
                          <textarea
                            type="text"
                            name="facebook"
                            placeholder="Enter your Faceboook Link...."
                            value={formData?.facebook || ""}
                            onChange={handleChange}
                          />
                          <textarea
                            type="text"
                            name="instagram"
                            placeholder="Enter your Instagram Link...."
                            value={formData?.instagram || ""}
                            onChange={handleChange}
                          />
                          <textarea
                            type="text"
                            name="linkedin"
                            placeholder="Enter your LinkedIn Link...."
                            value={formData?.linkedin || ""}
                            onChange={handleChange}
                          />
                          <textarea
                            type="text"
                            name="youtube"
                            placeholder="Paste Youtube Link...."
                            value={formData?.youtube || ""}
                            onChange={handleChange}
                          />
                          <div className="modal-buttons">
                            <button type="button" onClick={() => setShowModal(null)}>
                              Cancel
                            </button>
                            <button type="submit" disabled={isSaving}>
                              {isSaving ? "Saving..." : "Save"}
                            </button>
                          </div>
                        </>
                      )
                        /* ================= REGISTER ================= */
                        : selectedMenu === "Registerpage" ? (
                          <>
                            <input
                              name="name"
                              placeholder="Full Name"
                              value={formData?.name || ""}
                              onChange={handleChange}
                              required
                            />
                            <input
                              name="email"
                              type="email"
                              placeholder="Email"
                              value={formData?.email || ""}
                              onChange={handleChange}
                              required
                            />
                            {/* <input
                              name="password"
                              type="password"
                              placeholder="Password"
                              value={formData?.password || ""}
                              onChange={handleChange}
                              required
                            />
                            <input
                              name="confirmPassword"
                              type="password"
                              placeholder="Confirm Password"
                              value={formData?.confirmPassword || ""}
                              onChange={handleChange}
                              required
                            /> */}
                            <input
                              name="mobilenumber"
                              type="text"
                              placeholder="Mobile number"
                              value={formData?.mobilenumber || ""}
                              onChange={handleChange}
                              required
                            />
                            <input
                              name="address"
                              type="text"
                              placeholder="ENTER THE ADDRESS"
                              value={formData?.address || ""}
                              onChange={handleChange}
                              required
                            />
                            {/* ✅ HEADER IMAGE UPLOAD */}
                            <div className="upload-field">
                              <label className="upload-label">
                                Upload  Image
                                <input
                                  type="file"
                                  accept="image/*"
                                  onChange={(e) =>
                                    setFormData({
                                      ...formData,
                                      imageFile: e.target.files[0],
                                      image: URL.createObjectURL(e.target.files[0]),
                                    })
                                  }
                                />
                              </label>
                            </div>
                            {/* ✅ HEADER IMAGE PREVIEW */}
                            {formData?.image && (
                              <img
                                src={formData?.image}
                                alt="header preview"
                                className="preview-img"
                              />
                            )}
                            <div className="modal-buttons">
                              <button type="button" onClick={() => setShowModal(null)}> Cancel </button>
                              <button type="submit" disabled={isSaving}>
                                {isSaving ? "Registering..." : "Register"}
                              </button>
                            </div>
                          </>
                        ) : (
                          /* ================= OTHER MENUS ================= */
                          <>
                            <input
                              name="name"
                              placeholder="Name"
                              value={formData?.name || ""}
                              onChange={handleChange}
                              required
                            />
                            <input
                              name="descriptions"
                              placeholder="Description"
                              value={formData?.descriptions || ""}
                              onChange={handleChange}
                              required
                            />
                            <textarea
                              name="content"
                              placeholder="Content"
                              value={formData?.content || ""}
                              onChange={handleChange}
                              required
                            />
                            {/* IMAGE UPLOAD */}
                            <div className="upload-field">
                              <label className="upload-label"> Upload Image
                                <input type="file" accept="image/*"
                                  onChange={(e) =>
                                    setFormData({
                                      ...formData,
                                      imageFile: e.target.files[0],
                                      image: URL.createObjectURL(e.target.files[0]),
                                    })
                                  } /> </label>
                            </div>
                            {/* PREVIEW */}
                            {formData?.image && (
                              <img src={formData?.image} alt="preview" className="preview-img" />
                            )}

                            <div className="modal-buttons">
                              <button type="button" onClick={() => setShowModal(null)}> Cancel </button>
                              <button type="submit" disabled={isSaving}>
                                {isSaving ? "Saving..." : "Save"}
                              </button>
                            </div>
                          </>
                        )}
            </form>
          </div>
        </div>
      )}
      {/* PROFILE MODAL */}
      {showEditModal && (
        <div className="modal-overlay">
          <div className="modal-box">
            <h2>Edit {selectedMenu}</h2>

            {/* ================= CARS ================= */}
            {selectedMenu === "Cars" && (
              <>
                <input
                  type="text"
                  placeholder="Car Name"
                  value={editData?.name || ""}
                  onChange={(e) =>
                    setEditData({ ...editData, name: e.target.value })
                  }
                />

                <input
                  type="text"
                  placeholder="Car Type"
                  value={editData?.type || ""}
                  onChange={(e) =>
                    setEditData({ ...editData, type: e.target.value })
                  }
                />

                <input
                  type="number"
                  placeholder="Seats"
                  value={editData?.seats || ""}
                  onChange={(e) =>
                    setEditData({ ...editData, seats: e.target.value })
                  }
                />

                <input
                  type="number"
                  placeholder="Price"
                  value={editData?.price || ""}
                  onChange={(e) =>
                    setEditData({ ...editData, price: e.target.value })
                  }
                />
                {/* IMAGE UPLOAD */}
                <div className="upload-field">
                  <label className="upload-label">
                    Upload Image
                    <input
                      type="file"
                      accept="image/*"
                      onChange={(e) =>
                        setEditData({
                          ...editData,
                          imageFile: e.target.files[0],
                          image: URL.createObjectURL(e.target.files[0]),
                        })
                      }
                    />
                  </label>
                </div>

                {/* PREVIEW */}
                {editData?.image && (
                  <img
                    src={editData?.image}
                    alt="preview"
                    className="preview-img"
                  />
                )}
              </>
            )}

            {/* ================= SERVICES ================= */}
            {(selectedMenu === "Services" ||
              selectedMenu === "PickupTransportation") && (
                <>
                  <textarea
                    placeholder="Description"
                    value={editData?.description || ""}
                    onChange={(e) =>
                      setEditData({
                        ...editData,
                        description: e.target.value,
                      })
                    }
                  />
                  {/* IMAGE UPLOAD */}
                  <div className="upload-field">
                    <label className="upload-label">
                      Upload Image
                      <input
                        type="file"
                        accept="image/*"
                        onChange={(e) =>
                          setEditData({
                            ...editData,
                            imageFile: e.target.files[0],
                            image: URL.createObjectURL(e.target.files[0]),
                          })
                        }
                      />
                    </label>
                  </div>
                  {/* PREVIEW */}
                  {editData?.image && (
                    <img
                      src={editData?.image || ""}
                      alt="preview"
                      className="preview-img"
                    />
                  )}
                </>
              )}

            {/* ================= REVIEWS ================= */}
            {selectedMenu === "Reviews" && (
              <>
                <input
                  type="text"
                  placeholder="Customer Name"
                  value={editData?.name || ""}
                  onChange={(e) =>
                    setEditData({
                      ...editData,
                      name: e.target.value,
                    })
                  }
                />
                <textarea
                  placeholder="Review"
                  value={editData?.description || ""}
                  onChange={(e) =>
                    setEditData({
                      ...editData,
                      description: e.target.value,
                    })
                  }
                />
                <input
                  type="number"
                  placeholder="Rating"
                  value={editData?.rating || ""}
                  onChange={(e) =>
                    setEditData({
                      ...editData,
                      rating: e.target.value,
                    })
                  }
                />
                {/* IMAGE UPLOAD */}
                <div className="upload-field">
                  <label className="upload-label">
                    Upload Image
                    <input
                      type="file"
                      accept="image/*"
                      onChange={(e) =>
                        setEditData({
                          ...editData,
                          imageFile: e.target.files[0],
                          image: URL.createObjectURL(e.target.files[0]),
                        })
                      }
                    />
                  </label>
                </div>
                {/* PREVIEW */}
                {editData?.image && (
                  <img
                    src={editData?.image || ""}
                    alt="preview"
                    className="preview-img"
                  />
                )}
              </>
            )}
            {/* ================= HOMEPAGE ================= */}
            {selectedMenu === "HomePage" && (
              <>
                <input
                  type="text"
                  placeholder="Header Title"
                  value={editData?.headerTitle || ""}
                  onChange={(e) =>
                    setEditData({
                      ...editData,
                      headerTitle: e.target.value,
                    })
                  }
                />

                <textarea
                  placeholder="Header Description"
                  value={editData?.headerDescription || ""}
                  onChange={(e) =>
                    setEditData({
                      ...editData,
                      headerDescription: e.target.value,
                    })
                  }
                />
                {/* IMAGE UPLOAD */}
                <div className="upload-field">
                  <label className="upload-label">
                    Upload Image
                    <input
                      type="file"
                      accept="image/*"
                      onChange={(e) =>
                        setEditData({
                          ...editData,
                          imageFile: e.target.files[0],
                          image: URL.createObjectURL(e.target.files[0]),
                        })
                      }
                    />
                  </label>
                </div>
                {/* PREVIEW */}
                {editData?.image && (
                  <img
                    src={editData?.image || ""}
                    alt="preview"
                    className="preview-img"
                  />
                )}
              </>
            )}

            {/* ================= TRANSFER MENUS ================= */}
            {transferMenus.includes(selectedMenu) && (
              <>
                {/* 🔥 TOP HEADER SECTION */}
                <h3>Header Section</h3>
                <input
                  name="headerTitle"
                  placeholder="Header Title (Top Heading)"
                  value={editData?.headerTitle || ""}
                  onChange={(e) =>
                    setEditData({ ...editData, headerTitle: e.target.value })
                  }

                />
                <textarea
                  name="headerDescription"
                  placeholder="Header Description"
                  value={editData?.headerDescription || ""}
                  onChange={(e) =>
                    setEditData({ ...editData, headerDescription: e.target.value })
                  }
                />
                {/* ✅ HEADER IMAGE UPLOAD */}
                <div className="upload-field">
                  <label className="upload-label">
                    Upload Header Image
                    <input
                      type="file"
                      accept="image/*"
                      onChange={(e) =>
                        setEditData({
                          ...editData,
                          headerimageFile: e.target.files[0],
                          headerimage: URL.createObjectURL(e.target.files[0]),
                        })
                      }
                    />
                  </label>
                </div>
                {editData?.headerimage && (
                  <img
                    src={editData?.headerimage}
                    alt="header preview"
                    className="preview-img"
                  />
                )}
                {/* ✅ HEADER IMAGE PREVIEW */}

                <hr style={{ margin: "15px 0" }} />
                {/* 🔥 CARD SECTION */}
                <h3>Content Section</h3>
                <input
                  name="description"
                  placeholder="Card Title"
                  value={editData?.description || ""}
                  onChange={(e) =>
                    setEditData({ ...editData, description: e.target.value })
                  }
                />
                <textarea
                  name="content"
                  placeholder="Card Content"
                  value={editData?.content || ""}
                  onChange={(e) =>
                    setEditData({ ...editData, content: e.target.value })
                  }
                />
                {/* IMAGE UPLOAD */}
                <div className="upload-field">
                  <label className="upload-label">
                    Upload Image
                    <input
                      type="file"
                      accept="image/*"
                      onChange={(e) =>
                        setEditData({
                          ...editData,
                          imageFile: e.target.files[0],
                          image: URL.createObjectURL(e.target.files[0]),
                        })
                      }
                    />
                  </label>
                </div>
                {/* PREVIEW */}
                {editData?.image && (
                  <img
                    src={editData?.image || ""}
                    alt="preview"
                    className="preview-img"
                  />
                )}
              </>
            )}
            {/* ================= REGISTER PAGE ================= */}
            {selectedMenu === "Registerpage" && (
              <>
                <input
                  type="text"
                  placeholder="Name"
                  value={editData?.name || ""}
                  onChange={(e) =>
                    setEditData({
                      ...editData,
                      name: e.target.value,
                    })
                  }
                />
                <input
                  type="email"
                  placeholder="Email"
                  value={editData?.email || ""}
                  onChange={(e) =>
                    setEditData({
                      ...editData,
                      email: e.target.value,
                    })
                  }
                />
                <input
                  type="number"
                  placeholder="Mobile number"
                  value={editData?.mobilenumber || ""}
                  onChange={(e) =>
                    setEditData({
                      ...editData,
                      mobilenumber: e.target.value,
                    })
                  }
                />
                {/* <input
                  name="password"
                  type="password"
                  placeholder="please enter Password"
                  value={editData?.password || ""}
                  onChange={(e) =>
                    setEditData({
                      ...editData,
                      password: e.target.value,
                    })
                  }

                />
                <input
                  name="confirmPassword"
                  type="password"
                  placeholder="please enter Confirm Password"
                  value={editData?.confirmPassword || ""}
                  onChange={(e) =>
                    setEditData({
                      ...editData,
                      confirmPassword: e.target.value,
                    })
                  }

                /> */}
                <input
                  type="text"
                  placeholder="Address"
                  value={editData?.address || ""}
                  onChange={(e) =>
                    setEditData({
                      ...editData,
                      address: e.target.value,
                    })
                  }
                />

                {/* IMAGE UPLOAD */}
                <div className="upload-field">
                  <label className="upload-label">
                    Upload Image
                    <input
                      type="file"
                      accept="image/*"
                      onChange={(e) =>
                        setEditData({
                          ...editData,
                          imageFile: e.target.files[0],
                          image: URL.createObjectURL(e.target.files[0]),
                        })
                      }
                    />
                  </label>
                </div>
                {/* PREVIEW */}
                {editData?.image && (
                  <img
                    src={editData?.image || ""}
                    alt="preview"
                    className="preview-img"
                  />
                )}
              </>
            )}

            {/* ================= DEFAULT ================= */}
            {selectedMenu === "Contact" && (
              <>
                <input
                  type="text"
                  placeholder="Name"
                  value={editData?.name || ""}
                  onChange={(e) =>
                    setEditData({
                      ...editData,
                      name: e.target.value,
                    })
                  }
                />

                <input
                  placeholder="address"
                  value={editData?.address || ""}
                  onChange={(e) =>
                    setEditData({
                      ...editData,
                      address: e.target.value,
                    })
                  }
                />
                <input
                  placeholder="mobilenumber"
                  value={editData?.mobilenumber || ""}
                  onChange={(e) =>
                    setEditData({
                      ...editData,
                      mobilenumber: e.target.value,
                    })
                  }
                />
                <textarea
                  placeholder="Enter ur Map link...."
                  value={editData?.mapUrl || ""}
                  onChange={(e) =>
                    setEditData({
                      ...editData,
                      mapUrl: e.target.value,
                    })
                  }
                />
                <textarea
                  placeholder="Enter Ur Facebook link...."
                  value={editData?.facebook || ""}
                  onChange={(e) =>
                    setEditData({
                      ...editData,
                      facebook: e.target.value,
                    })
                  }
                />
                <textarea
                  placeholder="Enter UR lnstagram link...."
                  value={editData?.instagram || ""}
                  onChange={(e) =>
                    setEditData({
                      ...editData,
                      instagram: e.target.value,
                    })
                  }
                />
                <textarea
                  placeholder="Enter UR LinkedIn link...."
                  value={editData?.linkedin || ""}
                  onChange={(e) =>
                    setEditData({
                      ...editData,
                      linkedin: e.target.value,
                    })
                  }
                />
                <textarea
                  placeholder="Enter UR youtube link...."
                  value={editData?.youtube || ""}
                  onChange={(e) =>
                    setEditData({
                      ...editData,
                      youtube: e.target.value,
                    })
                  }
                />
              </>
            )}
            <div className="modal-buttons">
              <button onClick={() => setShowEditModal(false)}>
                Cancel
              </button>
              <button onClick={handleUpdate} disabled={isUpdating}>
                {isUpdating ? "Updating..." : "Update"}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default OwnerPage;
